export default __webpack_public_path__ + "static/media/abouttrading.5b866e47.jpg";